import { Theme } from '@mui/material';

export const getGridItemStyles = (theme: Theme, showLinearBackground: boolean, transparentBg: boolean) => ({
	background: transparentBg
		? 'transparent'
		: showLinearBackground
		? 'linear-gradient(to bottom, rgb(238, 239, 240) 0%, white 100%)'
		: `${theme.palette.backgrounds?.neutral}`,
	borderRadius: '0.5rem',
	width: '100%',
	textAlign: 'center',
	'&.MuiGrid-item': {
		paddingLeft: 0,
		paddingTop: 0,
		padding: '26%',
	},
	justifyContent: 'center',
	alingItems: 'center',
});
